export enum PurchaseCheckoutOption {
  CreditDebitCard = "CreditDebitCard",
  BankAccount = "BankAccount",
  MortgageBill = "MortgageBill",
}

export enum PurchaseAffiliation {
  Agent = "CoverTree Agent",
  D2C = "CoverTree D2C",
}

export interface TrackPurchaseProps {
  transaction_id: string;
  affiliation: PurchaseAffiliation;
  value: number;
  checkout_option: PurchaseCheckoutOption;
}

export interface TrackingContextState {
  trackEvent(name: string, props?: Record<string, unknown>): void;
  trackPurchase(props: TrackPurchaseProps): void;
}
